<template>
  <div>
    <b-alert v-if="alertHeadline || alertSubHeadline" show class="d-flex mb-4 mt-4 flex-column">
      <div><span v-html="alertHeadline"/></div>
      <div><span v-html="alertSubHeadline" /></div>
    </b-alert>
    <b-card class="terms-card">
      <b-card-title> {{ $t(termsModalTitle) }} </b-card-title>
      <b-card-text
        v-html="$t('ManageIdentity.Views.Account.Terms.SubHeadline')"
      />
      <b-tabs card>
        <b-tab :title="termsTitle" active>
          <b-card-text class="modal-text-scroll" v-html="tnc" />
        </b-tab>
        <b-tab :title="dataProtectionTitle">
          <b-card-text class="modal-text-scroll" v-html="data" />
        </b-tab>
        <template v-if="getConfig.context === 'Event'">
          <b-tab :title="termsTitleOrg" v-if="tncOrg">
            <b-card-text class="modal-text-scroll" v-html="tncOrg" />
          </b-tab>
          <b-tab :title="dataProtectionTitleOrg" v-if="dataOrg">
            <b-card-text class="modal-text-scroll" v-html="dataOrg" />
          </b-tab>
        </template>
      </b-tabs>
      <br />
      <b-form-checkbox
        id="checkbox-1"
        v-model="AcceptTermsOfUse"
        name="checkbox-1"
      >
        <span>{{ $t("ManageIdentity.Views.Account.Terms.AcceptTerms") }}</span>
      </b-form-checkbox>
      <b-button
        :disabled="!AcceptTermsOfUse || loading"
        class="login__box__login_btn terms"
        variant="primary"
        @click.prevent="registerUser()"
      >
        <template v-if="loading">
          <span class="login__box__loader" />
        </template>
        <template v-else>
          <span> Continue </span>
        </template>
      </b-button>
    </b-card>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import utils from '~/utilities/utils';
import accountPageMixins from "../../mixins/accountPageMixins";

export default {
  async mounted() {
    await this.loadTermsAndConditions();
  },
  props: ["ssoEvaluatedUserStatusAction"],
  data() {
    return {
      AcceptTermsOfUse: false,
      loading: false,
    };
  },
  mixins: [accountPageMixins],
  computed: {
    ...mapGetters({
      getConfig: 'ModuleConfig/moduleConfig',
    }),
    termsModalTitle() {
      return this.$t("ManageIdentity.Views.Account.Terms.Headline");
    },
    termsTitle() {
      return this.$t("ManageIdentity.Views.Account.Terms.TermsHeadline");
    },
    dataProtectionTitle() {
      return this.$t("ManageIdentity.Views.Account.Terms.DataHeadline");
    },
    termsTitleOrg() {
      return this.$t('ManageIdentity.Views.Account.Register.TermsCustom')
    },
    dataProtectionTitleOrg() {
      return this.$t('ManageIdentity.Views.Account.Register.DataCustom')
    },
    alertHeadline() {
      if (this.ssoEvaluatedUserStatusAction == 'ExternalUserUnknown') {
        return this.$t('ManageLoginComponent_AccountExternal.Headline_ExternalUserUnknown')
      }

      return null
    },
    alertSubHeadline() {
      if (this.ssoEvaluatedUserStatusAction == 'ExternalUserUnknown') {
        return this.$t('ManageLoginComponent_AccountExternal.SubHeadline_ExternalUserUnknown')
      }
      
      return null
    }
  },
  methods: {
    async registerUser() {
      this.loading = true
      if (this.AcceptTermsOfUse) {
        if (this.ssoEvaluatedUserStatusAction == "ExternalUserUnknown") {
          await this.ssoRegisterExternalAccount()
          .then((res) => {
            const url = utils.appendDefaultParamsToRoute({ path: 'correlate/userdatasync' })
            this.$router.replace(url)
          })
          .catch((err) => {
            this.loading = false          
          })
        }
        
        if (this.ssoEvaluatedUserStatusAction == "ExternalUserReadyToLogin") {
          await this.ssoAcceptTermsConditions()
          .then((res) => {
            const url = utils.appendDefaultParamsToRoute({ path: 'correlate/userdatasync' })
            this.$router.replace(url)
          })
          .catch((err) => {
            this.loading = false          
          })
        }
      }
    },
  },
};
</script>

<style scoped>
.modal-text-scroll {
  max-height: 40vh;
  overflow-y: scroll;
}

.btn.terms {
  margin: 1rem auto;
}

.login__box__loader {
  width: 16px;
  height: 16px;
  border: 2px solid #fff;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.login__box__login_btn:disabled {
  background-color: rgb(37, 37, 37);
  border-color: rgb(80, 80, 80);
  max-width: 200px;
}
</style>